var _excluded = ["className", "children", "center", "zoom", "scrollWheelZoom", "maxZoom", "minZoom", "touchZoom", "ContextualPane"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { forwardRef } from 'react';
import c from 'classnames';
import { MapContainer, TileLayer } from 'react-leaflet';
import { LeafletMapContextProvider } from '../LeafletMapContextProvider';
import './style.scss';
var LeafletMap = /*#__PURE__*/forwardRef(function (props, ref) {
  var className = props.className,
    children = props.children,
    _props$center = props.center,
    center = _props$center === void 0 ? [52.092876, 5.104480] : _props$center,
    _props$zoom = props.zoom,
    zoom = _props$zoom === void 0 ? 15 : _props$zoom,
    _props$scrollWheelZoo = props.scrollWheelZoom,
    scrollWheelZoom = _props$scrollWheelZoo === void 0 ? false : _props$scrollWheelZoo,
    _props$maxZoom = props.maxZoom,
    maxZoom = _props$maxZoom === void 0 ? 14 : _props$maxZoom,
    _props$minZoom = props.minZoom,
    minZoom = _props$minZoom === void 0 ? 7 : _props$minZoom,
    _props$touchZoom = props.touchZoom,
    touchZoom = _props$touchZoom === void 0 ? true : _props$touchZoom,
    ContextualPane = props.ContextualPane,
    restProps = _objectWithoutProperties(props, _excluded);
  var classes = c('Map', className);
  return /*#__PURE__*/React.createElement("div", {
    className: classes
  }, /*#__PURE__*/React.createElement(LeafletMapContextProvider, null, /*#__PURE__*/React.createElement(MapContainer, _extends({}, restProps, {
    ref: ref,
    center: center,
    zoom: zoom,
    scrollWheelZoom: scrollWheelZoom,
    maxZoom: maxZoom,
    minZoom: minZoom,
    touchZoom: touchZoom,
    zoomControl: false
  }), !children && /*#__PURE__*/React.createElement(TileLayer, {
    attribution: "\xA9 <a href=\"https://www.openstreetmap.org/copyright\">OpenStreetMap</a> contributors",
    url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
  }), children), ContextualPane && /*#__PURE__*/React.createElement(ContextualPane, null)));
});
export default LeafletMap;